<template>
  <div>
    <div class="row">
      <div class="col-lg-5 ">
        <b-form-group>
          <b-input-group size="md">
            <b-form-input
              :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
              v-model="pagination.filter"
              type="search"
              id="filterInput"
              debounce="500"
              @update="searchFilter()"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="!pagination.filter"
                @click="
                  pagination.filter = '';
                  searchFilter();
                "
                >{{ $t("PAGE.DEFAULT.TABLE.CLEAR") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <!-- <div class="col-lg-7 ">
        <b-button class="float-right" variant="primary" @click="downloadData()">
          <b-icon icon="file-earmark-text"></b-icon>
          {{
            $t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.DOWNLOADEXCEL"
            )
          }}
        </b-button>
      </div> -->
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-5 col-xxl-5">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="" align-self="center">
                  {{
                    $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.FROM")
                  }}
                </label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <date-picker v-model="from" :config="options"></date-picker>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-xxl-5">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="">{{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.TO")
                }}</label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <date-picker v-model="to" :config="options"></date-picker>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-xxl-2 pb-3">
            <b-button
              block
              class="float-right"
              type="submit"
              variant="primary"
              @click.prevent="searchFilter()"
            >
              {{
                $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.SEARCH")
              }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-content">
      <div class="table-responsive">
        <b-table
          id="organizations-table"
          :striped="false"
          :small="true"
          :items="items"
          :fields="fields"
          :sort-by.sync="pagination.orderBy"
          :sort-desc.sync="pagination.isDesc"
          :no-sort-reset="true"
          :no-local-sorting="true"
          :busy.sync="isBusy"
          :loading="false"
          :borderless="true"
          head-variant="light"
          @sort-changed="sortChange"
        >
          <template #cell(id)="data">
            <div class="text-right">
              <span v-if="pagination.isDesc">{{
                total -
                  (pagination.perPage * (pagination.page - 1) + data.index)
              }}</span>
              <span v-if="!pagination.isDesc">
                {{
                  pagination.perPage * (pagination.page - 1) + data.index + 1
                }}
              </span>
            </div>
          </template>

          <template #cell(customer_campaign_receipt_reward.is_approve)="data">
            <span v-if="data.item.is_approve == 0" class="text-warning">{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
            }}</span>
            <span v-else-if="data.item.is_approve == 1" class="text-success">{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
            }}</span>
            <span v-else>{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
            }}</span>
          </template>

          <template #cell(action)="data">
            <a
              href="javascript:"
              @click.prevent="openFormModal(data.item.id)"
              class="btn btn-icon btn-light btn-sm"
              v-b-tooltip.hover
              :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <inline-svg
                  src=" media/svg/icons/General/Edit.svg"
                ></inline-svg>
              </span>
            </a>
          </template>
        </b-table>

        <p class="text-center pt-3" v-if="items.length < 1">
          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
        </p>
      </div>

      <div class="row justify-content-between">
        <div div class="col-lg-3">
          <b-form-group
            id="name-input-group"
            :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
            label-for="name-input"
            label-cols="5"
            label-align-sm="left"
            label-size="lg"
          >
            <b-form-select
              v-model="pagination.perPage"
              id="perPageSelect"
              size="sm"
              :options="paginationOptions"
              @change="fetchData()"
            ></b-form-select>
          </b-form-group>
        </div>

        <div div class="col-lg-6">
          <b-pagination
            v-model="pagination.page"
            :total-rows="total"
            :per-page="pagination.perPage"
            @input="fetchData()"
            align="right"
          ></b-pagination>
        </div>
      </div>
    </div>

    <div class="form-modal">
      <b-modal
        size="xl"
        id="modal-form-receipt-reward"
        ref="modal"
        :title="this.$t('PAGE.CAMPAIGN.FORM.MODAL.CUSTOMER_RECEIPT')"
        :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
        :ok-disabled="is_disabled"
        :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
        @ok="handleSubmit"
      >
        <form ref="form" @submit.stop.prevent="handleSave">
          <b-row class="mb-1 text-center">
            <b-col class="col-image">
              <b-row id="ccr-recepit-image" class="mb-5">
                <b-col sm="12 text-center">
                  <a :href="form.receipt_image" target="_blank">
                    <img
                      :src="getImagePath"
                      class="receipt-image"
                      alt="Receipt image"
                    />
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-form">
              <b-row id="ccr-customer" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN_RECEIPT_REWARD.FORM.FIELDS.CUSTOMER")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="customer-input"
                    name="customer-input"
                    v-model="form.customer_fullname"
                    disabled
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row id="ccr-receipt-type" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN_RECEIPT_REWARD.FORM.FIELDS.RECEIPT_REWARD"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="receipt-type-input"
                    name="receipt-type-input"
                    v-model="form.reward_name"
                    disabled
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row id="ccr-is-approve" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN_RECEIPT_REWARD.FORM.FIELDS.IS_APPROVE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-select
                    v-model="form.is_approve"
                    id="is-approve-input"
                    :options="approval_list"
                    :disabled="is_disabled"
                  ></b-form-select>
                </b-col>
              </b-row>

              <b-row id="ccr-remark" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN_RECEIPT_REWARD.FORM.FIELDS.REMARK")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-textarea
                    id="remark-input"
                    name="remark-input"
                    v-model="form.remark"
                    rows="3"
                    max-rows="6"
                    :disabled="is_disabled"
                  ></b-form-textarea>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
// import datePicker from "vue-bootstrap-datetimepicker";
import {
  PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT_REWARD,
  FIND_CUSTOMER_CAMPAIGN_RECEIPT_REWARD,
  UPDATE_CUSTOMER_CAMPAIGN_RECEIPT_REWARD,
  SET_PAGINATION,
  SET_IS_CLEAR_PAGINATION,
  CLEAR_PAGINATION
} from "@/core/services/store/customer_campaign_receipt_reward.module";
import Swal from "sweetalert2";
import { Config } from "@/core/config/variable.config";

export default {
  name: "CustomerCampaignReceiptReward",
  mixins: [validationMixin],
  props: ["campaign_id"],
  components: {
    // datePicker
  },
  data() {
    return {
      from: null,
      to: null,
      is_disabled: false,
      select: [
        "customer_campaign_receipt_reward.id",
        "customer.first_name",
        "customer.last_name",
        "campaign_receipt_reward.reward_name",
        "campaign_receipt_reward.image",
        "customer_campaign_receipt_reward.point",
        "customer_campaign_receipt_reward.remark",
        "customer_campaign_receipt_reward.is_approve",
        "customer_campaign_receipt_reward.created_at",
        "customer_campaign_receipt_reward.status_id"
      ],
      fields: [
        {
          key: "id",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
          key_table: "customer_campaign_receipt_reward.id",
          sortable: false,
          isFilter: false,
          tdClass: "idField"
        },
        {
          key: "created_at",
          label: `${this.$t(
            "PAGE.CAMPAIGN_RECEIPT_REWARD.TABLE.FIELDS.CREATED_AT"
          )}`,
          key_table: "customer_campaign_receipt_reward.created_at",
          sortable: true,
          isFilter: false
        },
        {
          key: "customer_fullname",
          label: `${this.$t(
            "PAGE.CAMPAIGN_RECEIPT_REWARD.TABLE.FIELDS.CUSTOMER"
          )}`,
          key_table: "customer_fullname",
          sortable: false,
          isFilter: true
        },
        {
          key: "reward_name",
          label: `${this.$t(
            "PAGE.CAMPAIGN_RECEIPT_REWARD.TABLE.FIELDS.REWAED_NAME"
          )}`,
          key_table: "campaign_receipt_reward.reward_name",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt_reward.is_approve",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.TITLE")}`,
          key_table: "customer_campaign_receipt_reward.is_approve",
          sortable: true,
          isFilter: true
        },

        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          isFilter: false,
          tdClass: "actionField"
        }
      ],
      options: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      include: [],
      paginationOptions: [25, 50, 100, 200],
      total: 0,
      approval_list: [
        {
          value: 0,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
        },
        {
          value: 1,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
        },
        {
          value: 2,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
        }
      ],
      items: [],
      isBusy: false,
      form: {
        image: null,
        point: null,
        is_approve: null,
        remark: null
      }
    };
  },
  validations: {
    form: {}
  },
  computed: {
    isClearPagination: {
      get() {
        return this.$store.state.customer_campaign_receipt.isClearPagination;
      },
      set(value) {
        this.$store.commit(SET_IS_CLEAR_PAGINATION, {
          isClearPagination: value
        });
      }
    },
    pagination: {
      get() {
        return this.$store.state.customer_campaign_receipt.pagination;
      },
      set(value) {
        this.$store.commit(SET_PAGINATION, { pagination: value });
      }
    },
    getImagePath() {
      return `${Config.ADMIN_IMAGE_URL}/${this.form.image}`;
    }
  },
  mounted() {
    if (this.isClearPagination) {
      this.$store.commit(CLEAR_PAGINATION);
    }

    this.isClearPagination = true;
    this.fetchData();
  },
  methods: {
    getParams() {
      const orderByIndex = this.fields.findIndex(
        item => item.key === this.pagination.orderBy.toString()
      );
      return {
        page: this.pagination.page.toString(),
        perPage: this.pagination.perPage.toString(),
        orderBy: orderByIndex
          ? this.fields[orderByIndex].key_table
          : "created_at",
        isDesc: this.pagination.isDesc.toString(),
        filter: this.pagination.filter.toString(),
        from: this.from,
        to: this.to,
        filterBy: `${this.fields
          .map(item => {
            if (item.isFilter) return item.key;
          })
          .filter(item => !!item)}`,
        select: `${this.select}`,
        include: `${this.include}`,
        campaign_id: this.campaign_id
      };
    },
    fetchData() {
      this.$store
        .dispatch(PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT_REWARD, {
          params: this.getParams()
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data.data;
            this.total = data.data.total;
            if (this.total > 0 && this.items.length < 1) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    sortChange(event) {
      this.pagination.isDesc = event.sortDesc;
      this.pagination.orderBy = event.sortBy;
      this.fetchData();
    },
    searchFilter() {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.fetchData();
          Swal.close();
        }
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    openFormModal(id) {
      this.$store
        .dispatch(FIND_CUSTOMER_CAMPAIGN_RECEIPT_REWARD, { id })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.form = data.data;
            this.form.customer_fullname = `${data.data.first_name} ${data.data.last_name}`;
            this.form.campaign_id = this.campaign_id;
            this.is_disabled = this.form.is_approve === 2;
            this.$bvModal.show("modal-form-receipt-reward");
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.handleSave(this.form, this.form.id);
    },
    handleSave(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(UPDATE_CUSTOMER_CAMPAIGN_RECEIPT_REWARD, { id, data })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success" && data.data) {
                if (this.form.is_approve === 2) {
                  this.$emit("changing", "changeNotApproveReceiptReward");
                }
                Swal.fire({
                  icon: "success",
                  html: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")}`
                });
                this.$v.$reset();
                this.fetchData();
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-form-receipt-reward");
                });
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: this.$t("RESPONSE_MESSAGE." + data.error),
                  confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: error,
                confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
              });
            });
        }
      });
    }
  }
};
</script>

<style>
.receipt-image {
  width: 100%;
  margin-bottom: 15px;
  border: solid 2px #ddd;
  border-radius: 5px;
  cursor: pointer;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-center label {
  margin: 0;
}
</style>
